import { Options, Vue } from 'vue-class-component';
import { TrustAPI } from '@/shared/modules/trust-api';
import { Inject } from 'vue-property-decorator';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import TrustDataExternalExaminerModal from '../trust-data-external-examiner-modal/index.vue';
import { AppInsights } from '@/trust-admin-app/appInsights';

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    TrustDataExternalExaminerModal,
  }
})
export default class TrustDataExternalExaminerApproval extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private tableHeadings = [
    { text: 'Practice Name', value: 'name', sortable: false },
    { text: 'Address', value: 'address', sortable: false },
    { text: 'Form type', value: 'FormType', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Action', value: 'action', sortable: false },
  ];

  private loadingContent = false;
  private errorLoadingContent = false;
  private showEEModal = false;

  private searchText = '';
  private isSubmitted = true;
  private isApproved = false;
  private isRejected = false;

  private formType = 0; // 1: appoint, 2: terminate
  private actionType = 1 // 1: approve, 2: reject, 3: terminate, 4: view

  private externalExaminers: any[] = [
    {
      name: 'Practice 1',
      address: 'Address 1, Street 1, City 1, Country 1',
      formType: 'Form Type 1',
      status: 'Status 1',
      action: 'Action 1',
    }
  ];

  private selectedEE: any = {};

  mounted (){
    this.loadData();
  }

  private loadData() {
    this.loadingContent = true;
    this.errorLoadingContent = false;
    this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetEeRequestFormsPost({
      searchText: this.searchText,
      isSubmitted: this.isSubmitted,
      isApproved: this.isApproved,
      isRejected: this.isRejected,
    })
      .then((response) => {
        this.externalExaminers = response.data.data;
        this.loadingContent = false;
      })
      .catch((err) => {
        this.loadingContent = false;
        this.errorLoadingContent = true;
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load External Examiner data');
        this.ai.trackException('Error getting External Examiner data: ' + err);
      });
  }

  private get filteredSoftwareList() {
    return this.externalExaminers;
  }

  private openModal(ee: any, action: number) {
    this.formType = ee.eeRequestFormType?.id;
    this.actionType = action; // 1: approve, 2: reject, 3: view
    this.selectedEE = {... ee};
    this.showEEModal = true;
  }
  
}

